import s from "./Payment.module.css";

import { useState, useEffect, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { SwitchTransition, CSSTransition } from 'react-transition-group';

import { PaymentMethods } from "@components/Donat/PaymentMethods";
import { PaymentForm } from "@components/Donat/PaymentForm";

import { getFulldonat } from "@store/slices/sliceDonat";


const Payment = () => {
  const [dataDonat, setDataDonat] = useState({});

  const [showpaymentMethod, setShowpaymentMethod] = useState(true);

  const [paymentMethodHeight, setpaymentMethodHeight] = useState(null);
  const [paymentFormHeight, setpaymentFormHeight] = useState(0);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const donat = useSelector((state) => state.donat);

  useEffect(() => {
    dispatch(getFulldonat());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useMemo(() => {
    setDataDonat(donat);
  }, [donat]);

  const toggleComponent = useCallback(() => {
    setShowpaymentMethod(!showpaymentMethod);
  }, [showpaymentMethod]);

  const handleComponentMethodsEnter = (height) => {
    setpaymentMethodHeight(height);
  };

  const handleComponentFormEnter = (height) => {
    setpaymentFormHeight(height);
  };

  const myRootCSS = {
    '--payment-methods-height':  paymentMethodHeight + 'px',
    '--payment-form-height': paymentFormHeight + 'px',
  };

  const undateCurrentMethod = (selectMethod) => {
    const data = {
      ...dataDonat,
      currentMethod: selectMethod,
    }

    dispatch(getFulldonat(data));
  };

  return (
    <div className={s.donatBlock}>
      <h1 className={s.title}>{t("NavBar.donat")}</h1>

      <div style={paymentMethodHeight ? myRootCSS : {}} className={`${s.payment} ${!showpaymentMethod && paymentFormHeight ? s.form : ''}`}>
        <SwitchTransition mode="out-in">
          <CSSTransition
            key={showpaymentMethod ? 'methods' : 'form'}
            timeout={300}
            classNames={{
              enter: s.enter,
              enterActive: s.enterActive,
              exit: s.exit,
              exitActive: s.exitActive,
            }}
          >
            {showpaymentMethod ? (
              <PaymentMethods methods={dataDonat.payment?.items} updateMethod={undateCurrentMethod} onEnter={handleComponentMethodsEnter} toggle={toggleComponent} />
            ) : (
              <PaymentForm method={dataDonat.payment?.items[dataDonat.currentMethod]} updateMethod={undateCurrentMethod} onEnter={handleComponentFormEnter} toggle={toggleComponent}/>
            )}
          </CSSTransition>
        </SwitchTransition>
      </div>
    </div>
  );
}

export default Payment;